import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import * as React from 'react';
/**
 * Breaker icon.
 */
const Breaker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    {...props}
    className={cn('w-full', props.className)}
  >
    <g fill="none">
      <path
        fill="#1269FF"
        d="M15.545 25.6a27.307 27.307 0 0 0 5.608 9.6 17.973 17.973 0 0 0 11.574-6.322 28.936 28.936 0 0 1-13.014.318c-1.956-.39-3.54-1.78-4.168-3.596z"
      />

      <path
        fill="#5C9DFF"
        d="M18.236 35.2c.752 0 1.492-.05 2.219-.148a27.954 27.954 0 0 1-5.362-9.691 5.676 5.676 0 0 1-.278-1.756A5.58 5.58 0 0 1 16.122 20a28.013 28.013 0 0 0-6.304 12.915 16.584 16.584 0 0 0 8.418 2.285z"
      />

      <path
        fill="#9EC6FF"
        d="M1.636 22.449c1.126 4.776 4.161 8.79 8.238 11.151a27.755 27.755 0 0 1 6.335-12.85 5.282 5.282 0 0 1 5.064-1.763 26.497 26.497 0 0 0-5.545-.587 26.421 26.421 0 0 0-14.092 4.049z"
      />

      <path
        fill="#D1E3FF"
        d="M21.225 18.69a27.898 27.898 0 0 0-5.625-.574 27.617 27.617 0 0 0-14.3 3.956 16.975 16.975 0 0 1-.482-4.023c0-5.339 2.486-10.108 6.38-13.249 8.536 2.535 15.309 9.07 18.091 17.378a5.42 5.42 0 0 0-4.064-3.489z"
      />

      <path
        fill="#FFF"
        d="M35.182 14.962C35.182 7.314 28.708.8 18.486.8c-4.22 0-8.094 1.467-11.122 3.909 8.687 2.583 15.564 9.262 18.319 17.756.16.496.308 1.025.44 1.535 4.991-.108 9.059-4.101 9.059-9.038z"
      />

      <path
        fill="#003DAD"
        d="M20.39 19.385a4.603 4.603 0 0 1 4.349 3.018c.156.478.36 1.196.49 1.688l.17.65.685-.014C31.54 24.614 36 20.28 36 14.907 36 6.77 29.05 0 18.432 0c-4.38.014-8.533 1.57-11.678 4.073C2.632 7.373 0 12.387 0 18a17.94 17.94 0 0 0 .513 4.228c1.21 4.902 4.47 9.023 8.844 11.442A19.086 19.086 0 0 0 18.432 36c.8 0 1.616-.053 2.388-.15a18.535 18.535 0 0 0 11.926-6.508l.19-.228-.369-1.302-.711.183a26.983 26.983 0 0 1-6.855.864c-1.91 0-3.73-.192-5.526-.563-1.619-.318-2.935-1.468-3.454-2.97a4.044 4.044 0 0 1-.239-1.438c-.017-1.172.395-2.137 1.138-2.961a4.647 4.647 0 0 1 3.47-1.542zM18.432 1.688c9.827 0 15.84 6.165 15.84 13.22 0 4.216-3.33 7.678-7.554 8.094a33.385 33.385 0 0 0-.337-1.119C23.705 13.698 17.335 7.361 9.138 4.436c2.664-1.767 5.806-2.76 9.294-2.748zM1.728 18c0-4.925 2.235-9.34 5.769-12.333 6.722 2.104 12.231 6.595 15.448 12.556a6.452 6.452 0 0 0-1.32-.408 29.608 29.608 0 0 0-5.845-.59 29.333 29.333 0 0 0-13.824 3.487A15.766 15.766 0 0 1 1.728 18zM19.12 29.95c1.881.385 3.88.596 5.881.596 1.53 0 3.05-.124 4.528-.351a16.812 16.812 0 0 1-8.476 3.92 25.737 25.737 0 0 1-3.183-4.548c.398.166.815.296 1.25.383zm-.13 4.357c-.184.005-.37.008-.558.008a16.571 16.571 0 0 1-7.67-1.814c.666-2.86 1.8-5.513 3.336-7.915.051.442.152.88.285 1.271a27.9 27.9 0 0 0 4.608 8.45zM15.625 19.81c-3.001 3.285-5.268 7.37-6.414 11.797-3.292-2.133-5.763-5.373-6.86-9.176 3.972-2.261 8.496-3.527 13.43-3.518.276 0 .55.003.823.011a6.297 6.297 0 0 0-.979.886z"
      />
    </g>
  </svg>
);

export default Breaker;
